module.exports = __webpack_public_path__ + "img/psd.25a4e405.png";